const stockCountUnit = {
  beef: "cow",
  dairy: "cow",
  sheep: "head",
};

export const getStockCountUnit = (type) => stockCountUnit[type];
